import api from "./api";

// Capa de servicios API del dominio "waba-templates" (plantillas HSM de WhatsApp
// Cloud API / Meta). Doc 0367. Wrappers de transporte finos (capa API transversal).

export const listWabaTemplates = (params) =>
  api.get("/waba-templates", { params });

export const syncWabaTemplates = (whatsappId) =>
  api.post(`/waba-templates/sync/${whatsappId}`);

export const createWabaTemplate = (payload) =>
  api.post("/waba-templates", payload);

export const deleteWabaTemplate = (id) =>
  api.delete(`/waba-templates/${id}`);

export const uploadHeaderSample = (whatsappId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/waba-templates/upload-header-sample/${whatsappId}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const checkServiceWindow = (ticketId) =>
  api.get(`/waba-templates/check-window/${ticketId}`);

export const sendWabaTemplate = (ticketId, payload) =>
  api.post(`/waba-templates/send/${ticketId}`, payload);

// Extrae el texto del componente BODY de una plantilla Meta (para preview/columna).
export const getTemplateBodyText = (components) => {
  if (!Array.isArray(components)) return "";
  const body = components.find((c) => String(c.type).toUpperCase() === "BODY");
  return body?.text || "";
};
